export default __webpack_public_path__ + "static/media/middle_featured_2.7048b44f.jpg";